module.exports = __webpack_public_path__ + "/images/shop/icon/catalog/body_parts.svg";